import React, { useState } from 'react'
import ModalConfirmarDevolucionesQxFarmacia from './ModalConfirmarDevolucionesQxFarmacia'
import ModalValidacionNoDespachadoDevolucionesQx from './ModalValidacionNoDespachadoDevolucionesQx'
import ModalValidacionNoDiligenciadoHGDevolucionesQxF from './ModalValidacionNoDiligenciadoHGDevolucionesQxF'
import ModalValidacionPaqueteDevueltoDevolucionesQx from './ModalValidacionPaqueteDevueltoDevolucionesQx'
import ModalValidarEnfermeriaDevoluciones from './ModalValidarEnfermeriaDevoluciones'
import ModalVersuministrosDevolucionQxFarmacia from './ModalVersuministrosDevolucionQxFarmacia'
//import { postSuministrosDevolucionesQxFarmacia } from '../../../services/FarmaciaRuta'
import ModalSeDevolvioSuministrosDevolucionesQx from './ModalSeDevolvioSuministrosDevolucionesQx'
import ModalLoadingDevoluciones from './ModalLoadingDevoluciones'
import ModalValidarParcialmenteDiligenciadoDevolucionesQx from './ModalValidarParcialmenteDiligenciadoDevolucionesQx'

const TablaDevolucionesQxFarmacia = ({item,validarEnfermeria,dataEnfermeria,actualizarData}) => {
  const [modalOnConfirmarDevoluciones, setmodalOnConfirmarDevoluciones]=useState(false)
    const [mensajeSeleccionarEnfermero, setmensajeSeleccionarEnfermero]=useState(false)
    const [modalOnVersuministros,setmodalOnVersuministros]=useState(false)
    const [modalOnValidacionNoDiligenciadoHG, setmodalOnValidacionNoDiligenciadoHG]=useState(false)
    const [modalOnvalidacionPendienteDespacho, setmodalOnvalidacionPendienteDespacho]=useState(false)
    const [modalOnValidacionPaqueteDevuelto, setmodalOnValidacionPaqueteDevuelto]=useState(false)
    const [modalOnSuministrosDevueltos, setmodalOnSuministrosDevueltos]=useState(false)
    const [modalOnValidarParcialmenteDiligenciado, setmodalOnValidarParcialmenteDiligenciado]=useState(false)
    const [loading,setloading]=useState(false)
    const handleOnclickVersuministros=()=>{
      setmodalOnVersuministros(true)
    }
    // const handleOnclickDespachar=()=>{
      
    //   console.log(validarEnfermeria,'validaaaaa')
    //   if(validarEnfermeria === ''){
    //     // if(item.PQEdoDes === 'R'){
    //     //   setmodalOnValidacionPaqueteDevuelto(true)
    //     // }
    //     // else 
    //     const suministrosDevoluciones={
    //       ProEmpCod:'1',
    //       ProMCDpto:'001',
    //       ProCirCod: item.ProCirCod,
    //       PaqCod: item.PaqCod
    //     }
    //     setloading(true)
    //     postSuministrosDevolucionesQxFarmacia(suministrosDevoluciones).then((res)=>{
    //       //console.log(res.data,'data DEVOLCUIONES')
    //       setloading(false)
    //       const arrayDevoluciones = res.data
    //       const buscarSuministrosDevueltos = arrayDevoluciones.some((item)=> item.PQCaSuDv !== '.0000')
    //       //console.log(buscarSuministrosDevueltos,'TRUE')
    //       if(buscarSuministrosDevueltos){
    //         setmodalOnSuministrosDevueltos(true)
    //       }else if(item.PQEdoDes === 'P'){
    //         setmodalOnvalidacionPendienteDespacho(true)
    //       }
    //       else if(item.PqEdoGas === 'S'){
    //         setmodalOnValidacionNoDiligenciadoHG(true)
    //       }else{
    //         setmodalOnConfirmarDevoluciones(true)
    //       }
    //     })

        
        
    //   }else{
    //     setmensajeSeleccionarEnfermero(true)
    //   }
        
    // }
    
    const handleOnclickDespacharr=()=>{
      if(validarEnfermeria === ''){
        if(item.SuministrosDevueltos){
          setmodalOnSuministrosDevueltos(true)
        }else if(item.seUsaronTodosLosSuministros){
          setmodalOnSuministrosDevueltos(true)
        }
        else if(item.PQEdoDes === 'P'){
          setmodalOnvalidacionPendienteDespacho(true)
        }else if(item.PqEdoGas === 'S'){
          setmodalOnValidacionNoDiligenciadoHG(true)
        }else if(item.PqEdoGas === 'P'){
          setmodalOnValidarParcialmenteDiligenciado(true)
        }
        else{
          setmodalOnConfirmarDevoluciones(true)
        }
      }else{
        setmensajeSeleccionarEnfermero(true)
      }
    }
  return (
    <tbody>
    <tr className=" divide-y divide-slate-700 ">
      <td></td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
        {item.PQEdoDes === 'P' || item.PQEdoDes === 'C'? null : 
        <button
          onClick={handleOnclickDespacharr}
          type="button"
          className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
        >
          Devolver
        </button>
        }
      </td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">
        <button
          onClick={handleOnclickVersuministros}
          type="button"
          className="inline-block px-2 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight  rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out"
        >
          Ver Suministros
        </button>
      </td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
        {/* {item.MMCODM} */}
      </td>
      <td className={ item.SuministrosDevueltos?"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap ":"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"}>          
        {item.ProCirCod}
      </td>
      <td className={item.SuministrosDevueltos?"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap ":"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"}>          
        {/* {item.MPCedu} */}
      </td>
      <td className={item.SuministrosDevueltos?"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap ":"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap"}>          
        {item.MPCedu}
      </td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
        {item.MPNOMC}
      </td>
      <td className={(item.SuministrosDevueltos || item.seUsaronTodosLosSuministros)?"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left":"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left bg-[#bbf7d0]"}>          
        {item.PaqCod}
      </td>
      <td className={(item.SuministrosDevueltos || item.seUsaronTodosLosSuministros)?"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left":"text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left bg-[#bbf7d0]"}>          
        {item.PaqDes}
      </td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
        {item.ConsCod}
      </td>
      
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap text-left">          
        {item.ProFec? item.ProFec.split(' ')[0]:null}
      </td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
        {item.ProSedQr}
      </td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
        {item.ProEmpCod}
      </td>
      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
        {item.PQEdoDes === 'R'? 'Despacho Parcial':null}
        {item.PQEdoDes === 'P'? 'Pendiente Despacho':null}
        {item.PQEdoDes === 'D'? 'Despachado':null}
        {item.PQEdoDes === 'V'? 'Devuelto':null}
        {item.PQEdoDes === 'C'? 'Cancelado':null}
      </td>

      <td className="text-xs text-gray-900 font-medium px-3 py-2 whitespace-pre-wrap">          
        {item.BodQf}
      </td>
    </tr>
    {loading?<ModalLoadingDevoluciones/>:null}
    {mensajeSeleccionarEnfermero? <ModalValidarEnfermeriaDevoluciones setmensajeSeleccionarEnfermero={setmensajeSeleccionarEnfermero}/>:null}
    {modalOnConfirmarDevoluciones? <ModalConfirmarDevolucionesQxFarmacia item={item} setmodalOnConfirmarDevoluciones={setmodalOnConfirmarDevoluciones} dataEnfermeria={dataEnfermeria} actualizarData={actualizarData} cerrarModal={''}/>:null}
    {modalOnVersuministros? <ModalVersuministrosDevolucionQxFarmacia setmodalOnVersuministros={setmodalOnVersuministros} item={item}/>:null}
    {modalOnValidacionNoDiligenciadoHG? <ModalValidacionNoDiligenciadoHGDevolucionesQxF setmodalOnValidacionNoDiligenciadoHG={setmodalOnValidacionNoDiligenciadoHG} item={item} dataEnfermeria={dataEnfermeria} actualizarData={actualizarData}/>:null}
    {modalOnvalidacionPendienteDespacho? <ModalValidacionNoDespachadoDevolucionesQx setmodalOnvalidacionPendienteDespacho={setmodalOnvalidacionPendienteDespacho}/>:null}
    {modalOnValidacionPaqueteDevuelto? <ModalValidacionPaqueteDevueltoDevolucionesQx setmodalOnValidacionPaqueteDevuelto={setmodalOnValidacionPaqueteDevuelto}/>:null}
    {modalOnSuministrosDevueltos? <ModalSeDevolvioSuministrosDevolucionesQx setmodalOnSuministrosDevueltos={setmodalOnSuministrosDevueltos}/>:null}
    {modalOnValidarParcialmenteDiligenciado? <ModalValidarParcialmenteDiligenciadoDevolucionesQx setmodalOnValidarParcialmenteDiligenciado={setmodalOnValidarParcialmenteDiligenciado}/>:null}
  </tbody>
  )
}

export default TablaDevolucionesQxFarmacia